import React, { useEffect, useState, useCallback } from 'react';
import ReactMarkdown from 'react-markdown';
import { toast } from 'react-toastify';
import { projectTasksService } from '../services/api';

const ProjectWorkTasks = ({ projectId, canEdit }) => {
  const [tasks, setTasks] = useState([]);
  const [form, setForm] = useState({ title: '', description: '', display_order: 0, active: true });
  const [saving, setSaving] = useState(false);
  const [taskToDelete, setTaskToDelete] = useState(null);

  const load = useCallback(async () => {
    try {
      const t = await projectTasksService.list(projectId);
      setTasks(t);
    } catch {
      toast.error('Nepodarilo sa načítať štandardné vety.');
    }
  }, [projectId]);

  useEffect(()=>{ load(); }, [load]);

  const createItem = async () => {
    if (!form.title.trim()) {
      toast.warning('Názov je povinný.');
      return;
    }

    setSaving(true);
    try {
      await projectTasksService.create(projectId, form);
      setForm({ title:'', description:'', display_order:0, active:true });
      toast.success('Veta bola pridaná.');
      load();
    } catch {
      toast.error('Chyba pri vytváraní vety.');
    } finally {
      setSaving(false);
    }
  };

  const updateItem = async (id, patch) => {
    try {
      await projectTasksService.update(projectId, id, patch);
      toast.success('Veta bola aktualizovaná.');
      load();
    } catch {
      toast.error('Chyba pri úprave vety.');
    }
  };

  const deleteItem = async () => {
    if (!taskToDelete) return;
    try {
      await projectTasksService.remove(projectId, taskToDelete.id);
      toast.success('Veta bola zmazaná.');
      setTaskToDelete(null);
      load();
    } catch {
      toast.error('Chyba pri mazaní vety.');
    }
  };

  return (
    <div style={{ border:'1px solid #e9ecef', padding:'10px', borderRadius:'6px', marginTop:'10px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'8px' }}>
        <h4 style={{ margin:0 }}>🧾 Výkaz prác – štandardné vety</h4>
      </div>
      {canEdit && (
        <div style={{ display:'grid', gridTemplateColumns:'2fr 3fr 120px 120px', gap:'8px', alignItems:'center', marginBottom:'12px' }}>
          <input type="text" placeholder="Názov vety" value={form.title} onChange={(e)=>setForm(p=>({...p,title:e.target.value}))} />
          <input type="text" placeholder="Popis (Markdown)" value={form.description} onChange={(e)=>setForm(p=>({...p,description:e.target.value}))} />
          <input type="number" placeholder="Poradie" value={form.display_order} onChange={(e)=>setForm(p=>({...p,display_order: parseInt(e.target.value||'0',10)}))} />
          <div style={{ display:'flex', gap:'8px', alignItems:'center' }}>
            <label style={{ display:'flex', alignItems:'center', gap:'6px' }}>
              <input type="checkbox" checked={!!form.active} onChange={(e)=>setForm(p=>({...p,active:e.target.checked}))} /> Aktívna
            </label>
            <button type="button" onClick={createItem} disabled={saving}>{saving ? 'Ukladám...' : 'Pridať'}</button>
          </div>
        </div>
      )}

      <table className="documents-table">
        <thead>
          <tr>
            <th>Poradie</th>
            <th>Názov</th>
            <th>Popis</th>
            <th>Stav</th>
            {canEdit && <th style={{textAlign:'right'}}>Akcie</th>}
          </tr>
        </thead>
        <tbody>
          {tasks.map(t => (
            <tr key={t.id}>
              <td>{t.display_order || 0}</td>
              <td>{t.title}</td>
              <td>{t.description ? <ReactMarkdown>{t.description}</ReactMarkdown> : <span style={{color:'#6c757d'}}>—</span>}</td>
              <td><span className={`badge ${t.active? 'ok':'missing'}`}>{t.active? 'Aktívna':'Neaktívna'}</span></td>
              {canEdit && (
                <td style={{textAlign:'right'}}>
                  <button onClick={()=>updateItem(t.id, { active: !t.active })} className="download-btn" style={{marginRight:8}}>Prep./{t.active? 'Vypnúť':'Zapnúť'}</button>
                  <button onClick={()=>setTaskToDelete(t)} className="download-btn" style={{color:'#dc3545'}}>Zmazať</button>
                </td>
              )}
            </tr>
          ))}
          {tasks.length === 0 && (
            <tr>
              <td colSpan={canEdit?5:4} style={{textAlign:'center', color:'#6c757d', padding:'24px'}}>
                🧾 Zatiaľ nie sú nastavené štandardné vety pre výkaz prác.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {taskToDelete && (
        <div style={{ position:'fixed', inset:0, background:'rgba(15,23,42,0.45)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }} role="dialog" aria-modal="true">
          <div style={{ background:'#fff', borderRadius:'14px', padding:'24px', width:'min(420px, calc(100% - 32px))', boxShadow:'0 20px 50px rgba(15,23,42,0.25)', textAlign:'center' }}>
            <div style={{ fontSize:'32px', marginBottom:'8px' }}>⚠️</div>
            <h3 style={{ margin:'0 0 8px' }}>Zmazať vetu?</h3>
            <p style={{ color:'#6c757d', margin:'0 0 18px' }}>Veta <strong>{taskToDelete.title}</strong> sa odstráni zo štandardných možností výkazu prác.</p>
            <div style={{ display:'flex', gap:'10px', justifyContent:'center' }}>
              <button type="button" onClick={() => setTaskToDelete(null)}>Zrušiť</button>
              <button type="button" onClick={deleteItem} style={{ background:'#dc3545', color:'#fff', border:'none', borderRadius:'6px', padding:'8px 12px' }}>Áno, zmazať</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default ProjectWorkTasks;
